import p from "./NumberAttribute.js";
import m from "./selectAttribute.js";
import o from "./selectOption.js";
const d = Symbol(), a = Symbol(), g = Symbol(), y = Symbol("productLength"), T = Symbol("productWidth"), f = Symbol("productThickness"), b = Symbol("productLengthComp"), w = Symbol("productWidthComp"), S = Symbol("productThicknessComp"), h = Symbol("isQuick"), O = {
  // [_thicknessTypes]: [],
  //
  // set thicknessTypes(types) {
  //   this[_thicknessTypes] = types
  // },
  //
  // get thicknessTypes() {
  //   return this[_thicknessTypes]
  // },
  [d]: [],
  set plateTypes(t) {
    this[d] = t;
  },
  get plateTypes() {
    return this[d];
  },
  get edgeTypes() {
    return ["无封边", "全厚", "全薄"];
  },
  [a]: !0,
  // eslint-disable-next-line accessor-pairs
  set hasThickEdge(t) {
    this[a] = t;
  },
  [g]: !0,
  // eslint-disable-next-line accessor-pairs
  set hasThinEdge(t) {
    this[g] = t;
  },
  [h]: !1,
  // eslint-disable-next-line accessor-pairs
  set isQuick(t) {
    this[h] = t;
  },
  [y]: null,
  [b]: null,
  [T]: null,
  [w]: null,
  [f]: null,
  [S]: null,
  processMatchModeValue(t, e, s) {
    if (typeof e == "string") {
      e = e.replace(/,$/, ",null");
      try {
        const i = JSON.parse("[" + e + "]") || [];
        if (!Array.isArray(i))
          return [
            null,
            {
              type: "number",
              attr: new p(t, s, [0, null], 0.1),
              unit: "mm"
            }
          ];
        const c = [], N = i.reduce(
          (n, r) => Array.isArray(r) ? c.splice(0, c.length, ...r) && n : r !== null ? n.concat([r]) : n,
          []
        ), [W = 0] = N, _ = Number(W), M = isNaN(_) ? 0 : _;
        if (c.length) {
          const [n, r] = c.sort((L, u) => L - u), k = Number(M);
          return [
            isNaN(k) ? 0 : Math.max(k, n),
            {
              type: "number",
              attr: Object.assign(new p(t, s, [0, null], 0.1), {
                rules: [
                  {
                    validator: (L, u, l) => {
                      if (u < n)
                        return l(new Error(s + "小于最小值" + n));
                      if (u > r)
                        return l(new Error(s + "大于最大值" + r));
                      l();
                    },
                    trigger: "blur"
                  }
                ]
              }),
              unit: "mm"
            }
          ];
        }
        return [
          M,
          {
            type: "select",
            attr: new m(
              t,
              s,
              "请选择",
              N.map((n) => new o(n))
            ),
            after: "mm"
          }
        ];
      } catch (i) {
        console.log(i);
      }
    }
    return [
      e,
      {
        type: "number",
        attr: new p(t, s, [0, null], 0.1),
        unit: "mm"
      }
    ];
  },
  // eslint-disable-next-line accessor-pairs
  set productLength(t) {
    const [e, s] = this.processMatchModeValue("productLength", t, "长");
    this[y] = e, this[b] = s;
  },
  get productLength() {
    return this[y];
  },
  set productWidth(t) {
    const [e, s] = this.processMatchModeValue("productWidth", t, "宽");
    this[T] = e, this[w] = s;
  },
  get productWidth() {
    return this[T];
  },
  set productThickness(t) {
    const [e, s] = this.processMatchModeValue("productThickness", t, "厚");
    this[f] = e, this[S] = s;
  },
  get productThickness() {
    return this[f];
  },
  get components() {
    const t = [];
    return this[a] && t.push(new o("全厚")), this[g] && t.push(new o("全薄")), (!this[h] || this[h] && !t.length) && t.unshift(new o("无封边")), [
      {
        type: "select",
        attr: new m(
          "plateType",
          "板件类型",
          "",
          this.plateTypes.map((e) => new o(e))
        ),
        disabled: !0
      },
      this[b],
      this[w],
      this[S],
      // {
      //   type: 'select',
      //   attr: new SelectAttribute('productThickness', '厚', '', this.thicknessTypes.map(val => new SelectOption(val)))
      // },
      {
        type: "select",
        attr: new m("edgeType", "封边类型", "", t, !0)
      },
      {
        type: "number",
        attr: new p("num", "数量", [1, null], 1, null)
      }
    ].filter((e) => e !== null);
  }
};
export {
  O as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/banjianFormComps.js
// module id = 1247
// module chunks = 67